(function() {
  var players = [
    {
      accountId: '6091058965001',
      playerId: 'puURAdIPVJ',
      videoSelector: 'video-js[data-player="puURAdIPVJ"]'
    },
    {
      accountId: '6261636778001',
      playerId: '1PJLXqDKVA',
      videoSelector: 'video-js[data-player="1PJLXqDKVA"]'
    }
  ];

  players.forEach(function(player) {
    var playerScript = document.createElement('script');
    playerScript.src = `https://players.brightcove.net/${player.accountId}/${player.playerId}_default/index.min.js`;
    playerScript.async = true;
    document.head.appendChild(playerScript);

    playerScript.onload = function() {
      var videoElements = document.querySelectorAll(player.videoSelector);
      videoElements.forEach(function(videoElement) {
        videojs(videoElement);
      });
    };
  });
})();

